import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import { QUERY_KEY } from '@constants';
import { useEffect } from 'react';
import type { GetUserResponse } from 'viewup-api/v2';
import type { QueryParam } from 'viewup-lib/common';
import { AuthorizationError, TOKEN_NOT_EXIST } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';

// TODO : 추후 fsd 구조에 맞춰서 리팩터링 예정.
export const useGetMe = (params?: QueryParam<GetUserResponse>) => {
  const { accessToken, actions } = useTokenStore();

  const queryResult = useSDQuery({
    ...params?.options,
    enabled: params?.options?.enabled ?? !!accessToken,
    queryKey: [QUERY_KEY.ME],
    queryFn: async () => {
      const { data } = await serviceApi.user.getUser(withServiceRequestDefaults());
      return data;
    },
  });

  useEffect(() => {
    if (
      queryResult.error instanceof AuthorizationError &&
      queryResult.error.message === TOKEN_NOT_EXIST
    ) {
      actions.setToken('');
    }
  }, [queryResult.error, actions]);

  return queryResult;
};
